"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagDJ = function FlagDJ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65,11.8,12.18-190.4-120.29a7,7,0,0,0-2.6,5.35V139.3a7,7,0,0,0,2.6,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65a7,7,0,0,0,4.46,1.71H209.54a7.06,7.06,0,0,0,7.06-7.06V12.18H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4-120.29a7,7,0,0,1,4.46-1.71H209.54a7.06,7.06,0,0,1,7.06,7.06V12.18H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-119.59-19.71l-7.15,21.44-22.6.18a1.28,1.28,0,0,0-.76,2.32l18.19,13.43-6.82,21.56a1.29,1.29,0,0,0,2,1.44l18.39-13.15L-100,40.66a1.29,1.29,0,0,0,2-1.44l-6.82-21.56L-86.63,4.23a1.29,1.29,0,0,0-.75-2.32L-110,1.73l-7.15-21.44a1.29,1.29,0,0,0-2.45,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagDJ;
exports["default"] = _default;